import React from 'react';
import FavouriteManager from '../../services/favourite-manager';
import APIManager from '../../services/api-manager';
import ShortlistButton from './shortlist-button';
import CruiseDriver from "../search/cruise-driver";
import SearchTemplateResults from "../search/template-results";

export default class ShortlistShow extends React.Component {

    static defaultProps = {
        'renderDefaultText': true
    };

    constructor(props) {
        super(props);
        this.state = {
            result: null,
            favourites: null
        };

        this.favouriteManager = new FavouriteManager();
        this.APIManager = new APIManager();
    };

    componentDidMount() {
        this.loadFavourites();
        this.favouriteManager.onChange(this.loadFavourites);
    }

    loadFavourites = () => {
        let favourites = this.favouriteManager.getFavourites(this.props.type);
        this.setState({favourites: favourites}, this.loadFavoritesData);
    };

    loadFavoritesData = () => {
        if (this.props.type !== 'cruise') {
            this.APIManager.getShortlistData(this.props.type, JSON.stringify({'ids': this.state.favourites}), this.handleChange)
        }
    };

    handleChange = (response) => {
        this.setState({ result: response.result }
            ,() => { window.app.loadDataAttrBehaviours() }
        );
    };

    renderItem = (item, index) => {
        let idPrefix = item.type ? (item.type+'_') : ('');

        return (
            <div className="shortlist--item small-12 medium-6 large-4">
                <a className="shortlist-driver" key={this.props.type + '_' + index} href={item.url} style={{backgroundImage: `url(${item.image})`}}>
                    <ShortlistButton type={this.props.type} id={idPrefix+item.id} className="shortlist-button"/>
                    <h3 className="shortlist-driver--heading">{ item.title }</h3>
                </a>
            </div>
        );
    };

    renderItems = () => {
        if(this.state.result) return this.state.result.map( this.renderItem );
        return  this.renderDefault();
    };

    renderCruise = () => {
        return (<SearchTemplateResults solo={ this.props.solo } searchParams={{ allowEmptyPrice: true, solo:null, per_page: 99999, cruiseIds: this.state.favourites}}/>);
    };

    renderDefault = () => {
        if(!this.props.renderDefaultText) return <></>;
        return (
            <div>You Currently have no items in your shortlist you can add them while browsing ours cruise using the Heart icon.</div>
        )
    };

    render() {
        if (!this.state.favourites || this.state.favourites.length < 1 ) return this.renderDefault();
        if (this.props.type === 'cruise') return this.renderCruise();
        return this.renderItems();
    }

}